export const TRADE_PROMOTION_MANAGEMENT_PATH = "/trade-promotion-management"
export const PROMOTION_ACCRUALS_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/accruals`
export const MONTH_END_ACCRUAL_REPORT_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/accrual-report`
export const TRADE_RATE_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/trade-rate`
export const ACCRUAL_BANK_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/accrual-bank`
export const TRADE_REVIEW_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/trade-review`
export const PROMO_LIFT_REVIEW_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/promo-lift-review`
export const CREATE_PROMOTION_PATH = `${TRADE_PROMOTION_MANAGEMENT_PATH}/create`
